module.exports = __webpack_public_path__ + "fd5d466867bec95760eb60f1d29bc08f.png";